import { InactiveController } from './pages/inactive/inactive.controller'
import { BlockLoginsController } from './pages/block-logins/block-logins.controller'
import { LoginController } from './pages/login/login.controller'
import { LoginSsoController } from './pages/login-sso/login-sso.controller'
import { UserVerificationController } from './pages/user-verification/user-verification.controller'
import { RecoverPasswordController } from './pages/recover-password/recover-password.controller'
import { RememberPasswordController } from './pages/remember-password/remember-password.controller'
import { SignupController } from './pages/signup/signup.controller'
import { TwoFactorVerificationController } from './pages/two-factor-verification/two-factor-verification.controller'
import { UpdatePasswordController } from './pages/update-password/update-password.controller'
import { EmailConfirmationController } from './pages/email-confirmation/email-confirmation.controller'

/* @ngInject */
function routes ($stateProvider) {
  const redirectToApp = [
    '$rootScope',
    '$location',
    ($rootScope, $location) => {
      function getParamId (url, paramName) {
        const parsedUrl = new URL(`https://app.deskfy.io${url}`) // this https://app.deskfy.io is just a mock for the code to work properly
        const urlParams = new URLSearchParams(parsedUrl.search)
        const paramId = urlParams.get(paramName)

        return paramId
      }

      if ($location.$$search.next) {
        const nextUrl = $location.$$search.next.split('?')
        const urlFormatted = nextUrl[0]
        const urlArtCollection = $location.$$search.next.lastIndexOf('/')
        const urlCollection = $location.$$search.next.substring(0, urlArtCollection)

        if (!$rootScope.isDesktop) {
          if (urlFormatted === '/arts/templates') {
            const paramId = getParamId($location.$$search.next, 'previewId')
            window.location.href = `deskfy-app://MaterialPreview/${paramId}`
          } else if (urlCollection === '/arts/collection') {
            const paramId = getParamId($location.$$search.next, 'previewId')
            if (paramId) {
              window.location.href = `deskfy-app://MaterialPreview/${paramId}`
            } else {
              const collectionId = parseInt(nextUrl[0].split('/')[3])
              window.location.href = `deskfy-app://ViewAllCollections/${collectionId}`
            }
          } else if (urlFormatted === '/posts') {
            const paramId = getParamId($location.$$search.next, 'post')
            window.location.href = `deskfy-app://ViewAnnouncement/${paramId}`
          } else {
            window.location.href = 'deskfy-app://'
          }
        }
      }
    }
  ]

  $stateProvider
    .state('emailConfirmation', {
      url: '/email-confirmation?confirmationCode',
      public: true,
      params: {
        confirmationCode: null
      },
      views: {
        '': {
          templateUrl: '/auth/pages/email-confirmation/email-confirmation.html?$$REVISION$$',
          controller: EmailConfirmationController
        }
      }
    })
    .state('signup', {
      url: '/signup?company&email&name&inviteToken',
      public: true,
      views: {
        '': {
          templateUrl: '/auth/pages/signup/signup.html?$$REVISION$$',
          controller: SignupController
        }
      }
    })
    .state('login', {
      url: '/login?next',
      public: true,
      params: {
        next: '',
        skipSsoValidation: null,
        email: null
      },
      views: {
        '': {
          templateUrl: '/auth/pages/login/login.html?$$REVISION$$',
          controller: LoginController
        }
      },
      resolve: {
        redirectToApp
      }
    })
    .state('loginSso', {
      url: '/login/sso?email&error&jwt&userEmail&next',
      public: true,
      reloadOnSearch: false,
      params: {
        next: '',
        email: null,
        userEmail: null
      },
      views: {
        '': {
          templateUrl: '/auth/pages/login-sso/login-sso.html?$$REVISION$$',
          controller: LoginSsoController
        }
      }
    })
    .state('userVerification', {
      url: '/user/verification?emailSecretToken&securityCode',
      public: true,
      reloadOnSearch: false,
      params: {
        next: '',
        emailSecretToken: null,
        securityCode: null
      },
      views: {
        '': {
          templateUrl: '/auth/pages/user-verification/user-verification.html?$$REVISION$$',
          controller: UserVerificationController
        }
      }
    })
    .state('rememberPassword', {
      url: '/rememberPassword',
      public: true,
      views: {
        '': {
          templateUrl:
            '/auth/pages/remember-password/remember-password.html?$$REVISION$$',
          controller: RememberPasswordController
        }
      }
    })
    .state('inactive', {
      url: '/inactive',
      public: true,
      views: {
        '': {
          templateUrl: '/auth/pages/inactive/inactive.html?$$REVISION$$',
          controller: InactiveController
        }
      },
      params: {
        isPending: false
      }
    })
    .state('blockLogins', {
      url: '/unauthorized',
      public: true,
      views: {
        '': {
          templateUrl: '/auth/pages/block-logins/block-logins.html?$$REVISION$$',
          controller: BlockLoginsController
        }
      },
      params: {
        supportEmail: null
      }
    })
    .state('recoverPassword', {
      url: '/recoverPassword/:token',
      public: true,
      views: {
        '': {
          templateUrl:
            '/auth/pages/recover-password/recover-password.html?$$REVISION$$',
          controller: RecoverPasswordController
        }
      }
    })
    .state('twoFactorVerification', {
      url: '/twoFactorVerification/:token',
      public: true,
      params: {
        token: null,
        email: null,
        password: null
      },
      views: {
        '': {
          templateUrl:
            '/auth/pages/two-factor-verification/two-factor-verification.html?$$REVISION$$',
          controller: TwoFactorVerificationController
        }
      }
    })
    .state('updatePassword', {
      url: '/updatePassword/:token',
      public: true,
      params: {
        token: null,
        oldPassword: null,
        username: null,
        type: null
      },
      views: {
        '': {
          templateUrl:
            '/auth/pages/update-password/update-password.html?$$REVISION$$',
          controller: UpdatePasswordController
        }
      }
    })
}

export const authRoutes = routes
